export default __webpack_public_path__ + "static/media/placement.d36160c7.png";